import { EmploymentStatusResponse } from "../../api-models/response/EmploymentStatusResponse";
import { translationService } from "../translation/TranslationService";

export class EmploymentStatus {
  id: number;
  name: string;
  isDefault: boolean;

  constructor(employmentStatusResponse: EmploymentStatusResponse) {
    this.id = employmentStatusResponse.id;
    this.name = employmentStatusResponse.name;
    this.isDefault = employmentStatusResponse.isDefault;
  }

  get displayName() {
    const translationKey = `general.user.employment-status.${this.name}`;
    return translationService.translate(translationKey);
  }
}
